import React from 'react';

const PDDetail = (props) => {
    return (
        <div className="container">
            <a className="btn-brochure btn" href={props.item.BrochureLink}>Download Brochure PDF</a>
            <p>{props.item.Description}</p>
        </div>
    )
}

export default PDDetail;